import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const CookieConsent: React.FC = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('promoshop_cookie_consent');
        if (!consent) {
            // Show after a small delay for better UX
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('promoshop_cookie_consent', 'accepted');
        setIsVisible(false);
    };

    const handleDecline = () => {
        localStorage.setItem('promoshop_cookie_consent', 'declined');
        setIsVisible(false);
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 260, damping: 20 }}
                    className="fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:max-w-md z-[100]"
                >
                    <div className="bg-white/90 backdrop-blur-md border border-white/20 shadow-2xl rounded-2xl p-6 relative overflow-hidden">
                        {/* Decorative background element */}
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary to-secondary" />

                        <div className={`flex flex-col gap-4 ${isRTL ? 'rtl' : 'ltr'}`}>
                            <div className="flex items-start gap-3">
                                <div className="p-2 bg-primary/10 rounded-xl text-primary shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                </div>
                                <div>
                                    <h4 className="font-bold text-gray-900 mb-1">
                                        {isRTL ? 'ابقَ محادثاتك محفوظة ✨' : 'Gardez vos discussions ! ✨'}
                                    </h4>
                                    <p className="text-sm text-gray-600 leading-relaxed">
                                        {isRTL
                                            ? 'نستخدم ملفات تعريف الارتباط لنضمن لك بقاء محادثاتك مع مساعدنا الذكي دائماً هنا عند عودتك وتسهيل تصفحك. هل توافق؟'
                                            : 'Nous utilisons des cookies pour que votre historique de discussion reste disponible lors de votre prochaine visite et pour améliorer votre expérience. On active ça ?'}
                                    </p>
                                </div>
                            </div>

                            <div className="flex gap-3 justify-end mt-2">
                                <button
                                    onClick={handleDecline}
                                    className="px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                                >
                                    {isRTL ? 'لا شكرا' : 'Non merci'}
                                </button>
                                <button
                                    onClick={handleAccept}
                                    className="px-6 py-2 text-sm font-bold text-white bg-gradient-primary rounded-lg shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all text-center"
                                >
                                    {isRTL ? 'نعم، موافق' : "C'est parti !"}
                                </button>
                            </div>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieConsent;